import { login } from '@/auth';
import { ClientConfig } from '@/client-config';

export function LoginPage() {
  const queryParams = new URLSearchParams(window.location.search);
  const returnUrl = queryParams.get('returnUrl');
  let loginUrl = ClientConfig.loginUrl;

  if (returnUrl) {
    const uri = new URL(loginUrl);
    const urlWithoutParams = uri.origin + uri.pathname;
    loginUrl = `${urlWithoutParams}?returnUrl=${encodeURIComponent(returnUrl)}`;
  }

  return (
    <div className="border-neutral-5 shadow-md-8 mx-auto mt-40 flex w-fit flex-col justify-center gap-6 rounded-md border bg-white p-5">
      <h2 className="typ-headline-md text-blue-110 flex w-full justify-center">
        Leasingportalen
      </h2>
      <button
        className="border-neutral-40 hover:bg-neutral-10 w-full rounded-md border p-4 font-medium text-neutral-200"
        title="Sign in with MitID"
        onClick={() => login(loginUrl)}
      >
        <span className={'flex w-full items-center gap-4'}>
          Login med
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 234 62"
            version="1.1"
            height={'32px'}
          >
            <title>MitID identity blue</title>
            <desc />
            <g id="(2.)-MitID-logo" stroke="none" fill="none">
              <g
                id="scalable-vector"
                transform="translate(-576.000000, -264.000000)"
                fill="#0060E6"
              >
                <g
                  id="MitID-identity-blue"
                  transform="translate(576.000000, 264.000000)"
                >
                  <g id="group">
                    <g id="brand-/-logo-/-mitid_logo">
                      <path
                        d="M188.917342,0.941100331 L198.961909,0.941100331 C223.577531,0.941100331 234,14.3173314 234,31.0507435 C234,47.7841556 223.577531,61.1603866 198.961909,61.1603866 L188.917342,61.1603866 L188.917342,0.941100331 Z M181.403764,61.1604264 L128.80713,61.1604264 C130.306432,42.590944 141.427544,34.8143892 155.105447,34.8143892 C168.78335,34.8143892 179.904462,42.590944 181.403764,61.1604264 Z M169.663401,14.5845299 C169.663401,22.6394579 163.145388,29.1689007 155.105447,29.1689007 C147.065109,29.1689007 140.547493,22.6394579 140.547493,14.5845299 C140.547493,6.52999953 147.065109,0.000159070413 155.105447,0.000159070413 C163.145388,0.000159070413 169.663401,6.52999953 169.663401,14.5845299 Z M28.4911,48.6737966 L11.7927606,23.7236023 L11.7927606,61.1496891 L0,61.1496891 L0,3.11960941 L11.2267018,3.11960941 L28.7741295,30.5274416 L46.2272405,3.11960941 L57.2653883,3.11960941 L57.2653883,61.1496891 L45.3781522,61.1496891 L45.3781522,23.7236023 L28.8686049,48.6737966 L28.4911,48.6737966 Z M79.5330165,61.1496096 L67.8351283,61.1496096 L67.8351283,18.9024963 L79.5330165,18.9024963 L79.5330165,61.1496096 Z M92.2697379,28.3542216 L85.8545364,28.3542216 L85.8545364,18.9026553 L92.2697379,18.9026553 L92.2697379,7.46708333 L103.873548,7.46708333 L103.873548,18.9026553 L113.118646,18.9026553 L113.118646,28.3542216 L103.873548,28.3542216 L103.873548,46.8783689 C103.873548,50.1858404 105.665803,51.6982024 108.685048,51.6982024 C110.4777,51.6982024 112.458509,51.131514 113.779578,50.280885 L113.779578,60.6773295 C112.17548,61.5283562 109.345185,62 106.232258,62 C97.647297,62 92.2697379,57.7468548 92.2697379,48.3903331 L92.2697379,28.3542216 Z M80.6182935,6.94700261 C80.6182935,10.783781 77.5137028,13.8936076 73.683874,13.8936076 C69.8544421,13.8936076 66.7498514,10.783781 66.7498514,6.94700261 C66.7498514,3.11022425 69.8544421,0 73.683874,0 C77.5137028,0 80.6182935,3.11022425 80.6182935,6.94700261 Z"
                        id="mitid_logo"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </span>
      </button>
    </div>
  );
}

export default LoginPage;
